module.exports = __webpack_public_path__ + "img/cow.be5030ca.webp";